import Loading from '@/components/Loading'

import type { ILoadingProps } from '@/components/Loading'

import { memo } from 'react'

import type { FC, NamedExoticComponent, PropsWithChildren } from 'react'
import Empty from './Empty'
import Error from './Error'

import type { IErrorType, IErrorProps } from './Error'
import type { IEmptyProps } from './Empty'

type MixType = {
  error: IErrorType | IErrorProps
  empty: boolean | IEmptyProps
}

type IRenderProps = Partial<ILoadingProps> &
  Partial<MixType> & { className?: string; childClassName?: string }

type IPropsCase = {
  error: IErrorProps
  empty: IEmptyProps
}

const getProps = <A extends keyof MixType>(type: keyof IPropsCase, prop?: MixType[A]) => {
  if (!prop) return null
  if (typeof prop === 'object') return prop as IPropsCase[A]
  return {
    [type!]: prop,
  } as IPropsCase[A]
}

const Render: FC<IRenderProps> = ({
  loading,
  error,
  children,
  empty,
  className,
  childClassName,
  ...rest
}) => {
  const errors = getProps('error', !loading && error) as IErrorProps
  const empties = getProps('empty', !loading && empty) as IEmptyProps

  return (
    <Loading loading={Boolean(loading)} {...rest}>
      <Error {...errors} className={className}>
        <Empty childClassName={childClassName} {...empties} className={className}>
          {children}
        </Empty>
      </Error>
    </Loading>
  )
}

export { Error, Empty }

export default memo(Render) as NamedExoticComponent<PropsWithChildren<IRenderProps>>
